import React, { useEffect, useState } from "react";
import { List } from "antd";
import { ImLocation } from "react-icons/im";
import { FiSearch } from "react-icons/fi";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import styles from "./cleanerCTS.module.css";
import { AntdDropdown } from "../../../components";
import prof1 from "../../../assets/profile1.png";
import prof2 from "../../../assets/profile2.png";
import { useDispatch, useSelector } from "react-redux";
import TimeSheetMiddleware from "../../../store/Middlewares/TimeSheetMiddleware";
import { IMG_URL } from "../../../store/Apis";
import dummyImg from "../../../assets/dummy.png";
import CategoriesMiddleware from "../../../store/Middlewares/CategoriesMiddleware";
import { BsChevronRight } from "react-icons/bs";

function CleanersCTS() {
  // const [search, setsearch] = useState();
  const navigate = useNavigate();

  const dispatch = useDispatch();
  const UserList = useSelector(state => state.TimeSheetReducer.TimeSheetCleanerList)
  const UserListPagination = useSelector(state => state.TimeSheetReducer.TimeSheetCleanerListPagination)
  const category = useSelector((state) => state.CategoriesReducer.CategoryList)
  const [search, setSearch] = useState('')
  const [SelectedId, setSelectedId] = useState('')
  const { t, i18n } = useTranslation();

  useEffect(() => {
    getCleaners();
    getLanguage();
    getCategories();
  }, [])

  const getCategories = () => {
    dispatch(CategoriesMiddleware.getCategories())
  }

  const getLanguage = async () => {
    try {
      const language = localStorage.getItem('@selectedLanguage');
      i18n.changeLanguage(language)
    } catch (e) {
      console.log(e)
    }
  };

  const getCleaners = () => {
    let data = {
      search: search,
      next_page_url: undefined,
      Status: SelectedId,
    };
    dispatch(TimeSheetMiddleware.getTimeSheetCleaner(data));
  };


  const onPressLoadMore = () => {
    let data = {
      search: search,
      next_page_url: UserListPagination?.links?.next,
      Status: SelectedId,
    };
    dispatch(TimeSheetMiddleware.getTimeSheetCleaner(data));
  };


  const loadMore =
    UserListPagination?.links?.next ? (
      <div
        style={{
          textAlign: 'center',
          marginTop: 12,
          height: 32,
          lineHeight: '32px',
          display: 'flex', justifyContent: 'center'
        }}
      >
        <button onClick={onPressLoadMore} className={styles.loadMore_button}>
          Load More
        </button>
      </div>
    ) : null;

  const locations = [
    {
      id: 1,
      name: "Hope Fuentes",
      role: "Custodial Engineer",
      img: prof2
    },
    {
      id: 2,
      name: "James Halk",
      role: "Custodial Engineer",
      img: prof1
    }
  ];

  const renderItem = (item) => {
    return (
      <div
        className={styles.location_item}
        onClick={() =>
          navigate("/cleanerTaskSummary/Locations", { state: item })
        }
      >
        <div className={styles.flex}>
          <div className={styles.avtImg}>
            <img src={item?.profile_image ? IMG_URL + item?.profile_image : dummyImg} alt="" />
          </div>
          <div className={styles.heading_view}>
            <h1 className={styles.heading}>{item?.name}</h1>
            <text className={styles.span}>{t(item?.category_name)}</text>
          </div>
        </div>
        <div>
          <BsChevronRight size={30} color="white"/>
        </div>
      </div>
    );
  };
  const handleChange = value => {
    console.log(value);
  };
  return (
    <div className={styles.home_mainContainer}>
      <h1 className={styles.main_heading}>{t("Cleaners")}</h1>

      <div className={styles.filter_view}>
        <div style={{ width: '40%', margin: '12px 10px 12px 0px', }}>
          <input
            placeholder={t("Search")}
            onChange={(e) => setSearch(e.target.value)}
            className={styles.search_input}
          />

        </div>
        <div className={styles.flex} style={{ margin: '10px 0px' }}>
          <div style={{ width: '40%' }}>
            <AntdDropdown
              name={'Status'}
              className={'yellow_border_class'}
              placeholder={'Select Option'}
              style={{ width: '100%', height: '20px', borderColor: 'red' }}
              onChange={(val) => setSelectedId(val)}
              options={
                category?.map((item) => { return ({ value: item?.id, option: t(item?.name) }) })
              }
            />
          </div>
          <div>
            <button onClick={getCleaners} className={styles.search_button}>
              <FiSearch size={20} color={"#fff"} />
            </button>
          </div>
        </div>
      </div>
      <List dataSource={UserList} footer={loadMore} renderItem={renderItem} />
    </div>
  );
}

export default CleanersCTS;
